
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-55e21aab&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MyOrders.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./MyOrders.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-55e21aab!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./MyOrders.vue"),
  /* scopeId */
  "data-v-55e21aab",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/MyOrders.vue
// module id = 447
// module chunks = 1